/* eslint-disable import/no-default-export */
import {
  getModalTitle,
  getFreeText,
  getImportantPlatforms,
  getPlatforms,
  getPlatformsText,
  getAcceptButtonText,
} from './utils';
import './modal-multiposting-confirm.css';
import { selectMultipostingABGroup } from '../../../../../shared/selectors/publishTerms';

export default [
  '$scope',
  '$uibModalInstance',
  'deviceService',
  'geoService',
  'config',
  'store',
  'placingTermsApi',
  function ($scope, $uibModalInstance, deviceService, geoService, config, store, placingTermsApi) {
    const regionId = geoService.getLocationId();
    const state = store.getState();
    // TODO выпилить получение группы из placingTermsApi, когда новая ФВУ раскатится на все регионы
    const experimentGroup =
      selectMultipostingABGroup(state) || (placingTermsApi && placingTermsApi.multipostingABGroup);
    const platforms = getPlatforms(config, experimentGroup, regionId);
    const importantPlatforms = getImportantPlatforms(config, experimentGroup, regionId);
    const platformsCount = platforms.length + importantPlatforms.length;
    const price = config.get('multiPosting.price');
    const freeDate = config.get('multiPosting.freeDate');

    $scope.isMobile = deviceService.isMobile;

    this.images = {
      smile: require('./assets/smile.png'),
      smileSuccess: require('./assets/smile64.png'),
      phone: require('./assets/phone.png'),
      fire: require('./assets/fire.png'),
    };

    this.platformsCount = `${platformsCount || ''} других`;
    this.termsUrl = config.get('addformConfig.multiPosting.termsUrl');
    this.platformsText = getPlatformsText(platforms);
    this.importantPlatformsText = importantPlatforms.join(', ');
    this.tooltipText = platforms.join(', ');
    this.freeText = getFreeText(experimentGroup, freeDate);
    this.modalTitle = getModalTitle(platformsCount, price, experimentGroup);
    this.acceptButtonText = getAcceptButtonText(price, experimentGroup);
    this.isFreeSuccess = false;

    this.handleAcceptClick = () => {
      if (experimentGroup === 'C') {
        this.isFreeSuccess = true;

        return;
      }

      $uibModalInstance.close(null);
    };

    $scope.confirm = () => $uibModalInstance.close(null);
  },
];
